// extracted by mini-css-extract-plugin
module.exports = {"commonBtn":"styles_commonBtn__2uu1s","outlinedBtn":"styles_outlinedBtn__1pdLS"};